(function (angular) {
	'use strict';

	var multiFieldValidatedInputObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			errorMessage: '@',
			fieldOneState: '<',
			fieldTwoState: '<',
			fieldThreeState: '<?',
			label: '@'
		},
		controller: [MultiFieldValidatedInputFunction],
		controllerAs: 'multiFieldValidatedInput',
		transclude: true
	};

	angular
		.module('formValidationModule')
		.component('multiFieldValidatedInput', multiFieldValidatedInputObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/shared/form-validation/multi-field-validated-input.html';
	}

	function MultiFieldValidatedInputFunction() {
		var multiFieldValidatedInput = this;
		
		multiFieldValidatedInput.$onChanges = function(){
			var isTwoInputMultiField = angular.isUndefined(multiFieldValidatedInput.fieldThreeState);
			
			multiFieldValidatedInput.hasErrors = isTwoInputMultiField ? validateTwoInputMultiField() : validateThreeInputMultiField();
		};
		
		function validateTwoInputMultiField(){
			return multiFieldValidatedInput.fieldOneState || multiFieldValidatedInput.fieldTwoState;
		}
		
		function validateThreeInputMultiField(){
			return multiFieldValidatedInput.fieldOneState || multiFieldValidatedInput.fieldTwoState || multiFieldValidatedInput.fieldThreeState;
		}
	}
})(window.angular);